import { useState } from 'react';
import { message } from 'antd';
import { admissionService } from '../../../services/admission';
const { format, validate } = require('rut.js');

const usePatient = (form, updatePatientAttribute, index, setDisabled, patients) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const deletePreviusPatientValues = (documentType) => {
    updatePatientAttribute(index, 'profession', null);
    updatePatientAttribute(index, 'names', null);
    updatePatientAttribute(index, 'last_name', null);
    updatePatientAttribute(index, 'email', null);
    updatePatientAttribute(index, 'phone', null);
    form.setFieldsValue({
      documentType: documentType,
      profession: null,
      names: null,
      last_name: null,
      email: null,
      phone: null,
    });
  };

  const fetchPatient = async (documentType, documentNumber, alert = false) => {
    setIsLoading(true);
    let response = [];
    try {
      response = await admissionService.getPatient({
        document_type: documentType,
        document_number: documentNumber,
      });
    } catch (error) {
      console.error(error);
      let errorMessage = 'Error al obtener el paciente';
      if (error === 'blocked') {
        errorMessage = `No es posible reservar para este paciente ${documentNumber}.`;
        deletePreviusPatientValues(documentType);
        response = error;
      }
      if (alert) {
        message.error({
          content: errorMessage,
          style: {
            marginTop: '30vh',
            fontSize: 16,
          },
        });
      }
    } finally {
      setIsLoading(false);
      return response;
    }
  };

  const getPatient = async (documentNumber, documentType) => {
    setData(null);
    let inputValue = documentNumber;
    let searchPatient;
    if (inputValue) {
      if (documentType === 'rut') {
        const validateRut = validate(inputValue);

        if (validateRut) {
          searchPatient = await fetchPatient('rut', format(inputValue, { dots: false }), true);
        }
      } else {
        searchPatient = await fetchPatient(documentType, inputValue, true);
      }

      let block = false;
      for await (const patient of patients) {
        const formatDocumentNumber = patient.document_type === 'rut' ? format(patient.document_number, { dots: false }) : patient.document_number;
        const result = await fetchPatient(patient.document_type, formatDocumentNumber);
        if (!block) {
          block = result === 'blocked';
        }
      }
      setDisabled((disabled) => ({ ...disabled, patientBlocking: block }));
    }

    if (searchPatient?.length > 0 && searchPatient[0]) {
      setData(searchPatient[0]);
    }
  };

  return { isLoading, data, getPatient };
};

export default usePatient;
